"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createDonutChartConfig(options) {
    var total = 0;
    var normalisedData;
    if (options.data.length === 0) {
        normalisedData = [1];
    }
    else {
        total = options.data.reduce(function (acc, curr) { return (acc += curr); });
        normalisedData = options.data.map(function (datum) {
            var percentage = (datum / total) * 100;
            if (percentage < 10) {
                return total * 0.05;
            }
            return datum;
        });
    }
    var breakpoints = getBreakpoints(options.sizes);
    return {
        series: normalisedData,
        options: {
            dataLabels: {
                enabled: false,
            },
            responsive: breakpoints,
            stroke: {
                width: total === 0 || normalisedData.length === 1 ? 0 : 0.5,
            },
            states: {
                hover: {
                    filter: {
                        type: "darken",
                        value: 0.7,
                    },
                },
                active: {
                    allowMultipleDataPointsSelection: false,
                },
            },
            chart: {
                id: options.id,
                toolbar: {
                    show: false,
                },
                animations: {
                    enabled: true,
                    dynamicAnimation: {
                        enabled: true,
                    },
                },
            },
            plotOptions: {
                pie: {
                    expandOnClick: true,
                    donut: {
                        size: "40%",
                    },
                },
            },
            legend: {
                show: false,
            },
            tooltip: {
                enabled: options.tooltipFired !== undefined,
                custom: options.tooltipFired,
            },
            colors: total === 0 ? ["#e5e5e6"] : options.colours,
            labels: options.labels,
        },
    };
}
exports.createDonutChartConfig = createDonutChartConfig;
function getBreakpoints(sizes) {
    if (!sizes) {
        return [];
    }
    return sizes.map(function (size) { return ({
        breakpoint: size.maxWidth,
        options: {
            chart: {
                width: size.chartWidth,
            },
        },
    }); });
}
